import { useContext } from 'react';
import { OverlayContext } from './OverlayContext';

export function useOverlayContext() {
  return useContext(OverlayContext);
}
